export const formatTime = (sec: number): string => {
  const hours = Math.floor(sec / 3600);
  const minutes = Math.floor((sec % 3600) / 60);
  const seconds = sec % 60;

  const minutesStr = minutes.toString().padStart(2, '0');
  const secondsStr = seconds.toString().padStart(2, '0');

  if (hours === 0) {
    return `${minutesStr}:${secondsStr}`;
  }

  return `${hours}:${minutesStr}:${secondsStr}`;
};

export const formatMinutesToHoursAndMinutes = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours === 0) {
    return `${remainingMinutes} m`;
  }

  if (remainingMinutes === 0) {
    return `${hours} h`;
  }

  return `${hours}h ${remainingMinutes}m`;
};
